export const GOOGLE_PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=ai.controla.app";
